import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionProRes = props => {
  return (
    <Hoc>
      <CvItem date1="2016" imgSrc="Method.jpg" id="method-architects">
        <CvItemDesc descBold="Method Architects" descNormal="Tehran,&nbsp;Iran" descComment="" />
        <CvItemDetail primary bold>
          {"Founder & Principal"}
        </CvItemDetail>
        <CvItemDetail>
          Administrated the office, Communicated with the clients, Negotiated contacts and Formulated projects (timing, planning, execution, etc.)
        </CvItemDetail>
        <CvItemDetail>
          Managed the design, development and delivery procedure of several projects (of different scales and functions)
        </CvItemDetail>
        <CvItemDetail>
          Hired and directed the design team, Delegated and outsources tasks, Acquired services and Procured products
        </CvItemDetail>
        <CvItemDetail>
          Conducted projects initial studies and proposals
        </CvItemDetail>
        <CvItemDetail>
          Supervised the construction process of  a few projects
        </CvItemDetail>
      </CvItem>
      <CvItemDetail primary bold>
        SELECTED PROJECTS :
      </CvItemDetail>

      <CvItem date1="Sep 2018" date2="Sep 2019">
        <CvItemDesc
          descBold="Plus Polymer Head Office"
          descNormal="Science and Technology park,&nbsp;Irani&nbsp;Land,&nbsp;Iran"
          descComment="Construction&nbsp;Pending"
        />
        <CvItemDetail primary bold>
          6,500 m2 - Head Office Complex
        </CvItemDetail>
      </CvItem>

      <CvItem date="Jul 2018">
        <CvItemDesc
          descBold="Baboolsar Multifunctional Complex"
          descNormal="Baboolsar,&nbsp;Mazandaran,&nbsp;Iran"
          descComment="Studies"
        />
        <CvItemDetail primary bold>
          80,000 m2 - Multi-functional Hybrid Building
        </CvItemDetail>
      </CvItem>

      <CvItem date1="Mar 2018" date2="May 2020">
        <CvItemDesc descBold="Tabnak Building" descNormal="Arak,&nbsp;Markazi,&nbsp;Iran" descComment="Built" />
        <CvItemDetail primary bold>
          800 m2 - Residential &amp; Interiors
        </CvItemDetail>
      </CvItem>

      <CvItem date1="May 2013" date2="Feb 2016">
        <CvItemDesc
          descBold="Villa 101"
          descNormal="Arian&nbsp;Garden&nbsp;City,&nbsp;Koohsar,&nbsp;Iran"
          descComment="Built"
        />
        <CvItemDetail primary bold>
          500 m2 Residential Building &amp; 5000 m2 Landscape
        </CvItemDetail>
        <CvItemDetail> Shortlisted in Memar magazine award 95 </CvItemDetail>
        <CvItemDetail> Published by a number of domestic magazines </CvItemDetail>
      </CvItem>

      <CvItem date1="Apr 2018" date2="Dec 2019">
        <CvItemDesc
          descBold="Mehrshahr&nbsp;Residential&nbsp;Building"
          descNormal="Mehrshahr,&nbsp;Alborz,&nbsp;Iran"
          descComment="Built"
        />
        <CvItemDetail primary bold>
          1,700 m2 - Residential Building
        </CvItemDetail>
      </CvItem>

      <CvItem date1="Dec 2017" date2="Oct 2019">
        <CvItemDesc descBold="Villa Aftab" descNormal="Mohammad Shahr,&nbsp;Alborz,&nbsp;Iran" descComment="Built" />
        <CvItemDetail primary bold>
          250 m2 - Private villa
        </CvItemDetail>
      </CvItem>

      <CvItem date="Jul 2016">
        <CvItemDesc descBold="Jalal Office Building" descNormal="Tehran,&nbsp;Iran" descComment="Built" />
        <CvItemDetail primary bold>
          Facade design - Office Building
        </CvItemDetail>
      </CvItem>

      {/* <CvItem date="Aug 2017">
        <CvItemDesc
          descBold="Dr Karimi Drugstore"
          descNormal="Tehran,&nbsp;Iran"
          descComment="Interior-&nbsp;Design&nbsp;Proposal"
        />
      </CvItem>

      <CvItem date="Aug 2017">
        <CvItemDesc
          descBold="Candid Cloth Shop"
          descNormal="Tehran,&nbsp;Iran"
          descComment="Interior-&nbsp;Design&nbsp;Proposal"
        />
      </CvItem>

      <CvItem date="Jul 2017">
        <CvItemDesc
          descBold="Amurski 351 Flat"
          descNormal="Kiev,&nbsp;Ukraine"
          descComment="Interior-&nbsp;Design&nbsp;Proposal"
        />
      </CvItem> */}

      <div className="cv-section__comment">
        * Please visit <a href="http://www.method.ir">www.method.ir</a> or{" "}
        <a href="http://www.vahidghodsi.com">www.vahidghodsi.com</a> for&nbsp;the&nbsp;complete&nbsp;list&nbsp;of&nbsp;projects.
      </div>
    </Hoc>
  );
};

export default cvSectionProRes;
